var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7 11.275C6.9 11.075 6.996 10.8334 6.988 10.55C6.98 10.2667 6.87566 10.025 6.675 9.82505L3.85 7.00005H15C15.2833 7.00005 15.521 6.90405 15.713 6.71205C15.905 6.52005 16.0007 6.28272 16 6.00005C16 5.71672 15.904 5.47905 15.712 5.28705C15.52 5.09505 15.2827 4.99938 15 5.00005H3.85L6.7 2.15005C6.9 1.95005 7 1.71238 7 1.43705C7 1.16172 6.9 0.924382 6.7 0.725049C6.5 0.525049 6.26233 0.425049 5.987 0.425049C5.71166 0.425049 5.47433 0.525049 5.275 0.725049L0.699997 5.30005C0.599997 5.40005 0.528996 5.50838 0.486996 5.62505C0.444996 5.74172 0.424329 5.86672 0.424995 6.00005C0.424995 6.13338 0.445997 6.25838 0.487997 6.37505C0.529997 6.49172 0.600663 6.60005 0.699997 6.70005L5.3 11.3C5.48333 11.4834 5.71233 11.575 5.987 11.575C6.26166 11.575 6.49933 11.475 6.7 11.275Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.d6f5fa8ffb5d7793b4c86312113ccb28.svg";
export { ForwardRef as ReactComponent };